module.exports = __webpack_public_path__ + "static/media/18.07fbc787.png";